/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassSignupInstructorEligibilityStatus,
  ClassSignupInstructorEligibilityStatusOptional,
  ClassSignupInstructorEligibilityStatusMetaI,
  ClassSignupInstructorEligibilityStatusTrackedI,
} from "./class-signup-instructor-eligibility-status";
import {
  ClassSignupInstructorEligibilityStatusTracked,
  ClassSignupInstructorEligibilityStatusMeta,
} from "./class-signup-instructor-eligibility-status";

/**
 *
 * @export
 * @interface ClassSignupInstructorEligibilityDTO
 */
export interface ClassSignupInstructorEligibilityDTOOptional {
  /**
   *
   * @type {ClassSignupInstructorEligibilityStatus}
   * @memberof ClassSignupInstructorEligibilityDTO
   */
  status?: ClassSignupInstructorEligibilityStatus;
  /**
   *
   * @type {string}
   * @memberof ClassSignupInstructorEligibilityDTO
   */
  message?: string;
}

export interface ClassSignupInstructorEligibilityDTO extends ClassSignupInstructorEligibilityDTOOptional {
  /**
   *
   * @type {ClassSignupInstructorEligibilityStatus}
   * @memberof ClassSignupInstructorEligibilityDTO
   */
  status: ClassSignupInstructorEligibilityStatus;
  /**
   *
   * @type {string}
   * @memberof ClassSignupInstructorEligibilityDTO
   */
  message?: string;
}

export interface ClassSignupInstructorEligibilityDTOTrackedI {
  /**
   *
   * @type {ClassSignupInstructorEligibilityStatus}
   * @memberof ClassSignupInstructorEligibilityDTO
   */
  status?: ClassSignupInstructorEligibilityStatus;
  statusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSignupInstructorEligibilityDTO
   */
  message?: string;
  messageIsSet: boolean;
}

transformDatesMap.set(
  "ClassSignupInstructorEligibilityDTO",
  function (model: ClassSignupInstructorEligibilityDTO) {},
);

export type ClassSignupInstructorEligibilityDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  status: PropertyMeta<ClassSignupInstructorEligibilityStatusMetaI>;
  //isDate: false
  //isDatetime: false
  message: PropertyMeta<MetaTypeBase<string>>;
}>;

export var ClassSignupInstructorEligibilityDTOMeta: ClassSignupInstructorEligibilityDTOMetaI =
  {} as ClassSignupInstructorEligibilityDTOMetaI;
ClassSignupInstructorEligibilityDTOMeta = typeMeta(
  "ClassSignupInstructorEligibilityDTO",
  {
    status: propertyMeta(
      "status",
      false,
      true,
      false,
      ClassSignupInstructorEligibilityStatusMeta,
    ),
    message: propertyMeta("message", false, false, false, MetaTypesBase.string),
  },
);

const metaI = ClassSignupInstructorEligibilityDTOMeta;

registerMeta(() => {});

export class ClassSignupInstructorEligibilityDTOTracked implements ClassSignupInstructorEligibilityDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  status__I?: ClassSignupInstructorEligibilityStatus = undefined;
  statusIsSet: boolean = false;
  set status(v: undefined | ClassSignupInstructorEligibilityStatus) {
    if (v !== undefined) {
      this.status__I = v;
      this.statusIsSet = true;
    } else {
      this.status__I = v || undefined;
      this.statusIsSet = true;
    }
    this.changeTracker = true;
  }
  get status() {
    return this.status__I;
  }
  message__I?: string = undefined;
  messageIsSet: boolean = false;
  set message(v: undefined | string) {
    if (v !== undefined) {
      this.message__I = v;
      this.messageIsSet = true;
    } else {
      this.message__I = v || undefined;
      this.messageIsSet = false;
    }
    this.changeTracker = true;
  }
  get message() {
    return this.message__I;
  }
  constructor(
    config?: ClassSignupInstructorEligibilityDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: ClassSignupInstructorEligibilityDTOOptional,
    options?: AssignOptions,
  ): ClassSignupInstructorEligibilityDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.status && this.statusApplyFilter(optionsRequired.filter)) {
      this.status = config.status;
      if (optionsRequired.unassign) this.statusIsSet = false;
      else this.statusIsSet = true;
    }
    if (config.message && this.messageApplyFilter(optionsRequired.filter)) {
      this.message = config.message;
      if (optionsRequired.unassign) this.messageIsSet = false;
      else this.messageIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(
    filter?: FilterVarsType,
  ): ClassSignupInstructorEligibilityDTOTrackedI {
    const cloned = {} as ClassSignupInstructorEligibilityDTOTrackedI;
    if (
      this.statusIsSetDeep() &&
      this.statusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.statusIsSet = true;
      cloned.status = this.status;
    } else {
      //cloned.statusIsSet = false
    }
    if (
      this.messageIsSetDeep() &&
      this.messageApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.messageIsSet = true;
      cloned.message = this.message;
    } else {
      //cloned.messageIsSet = false
    }
    return cloned;
  }
  unassignAll(
    filter?: FilterVarsType,
  ): ClassSignupInstructorEligibilityDTOTrackedI {
    if (!this.statusApplyFilter(filter)) this.statusIsSet = false;

    if (!this.messageApplyFilter(filter)) this.messageIsSet = false;

    return this;
  }
  statusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupInstructorEligibilityDTOMeta.status,
      ClassSignupInstructorEligibilityDTOMeta,
      this.status,
      this,
    );
  }
  statusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.statusIsSet && this.statusApplyFilter(filter)) return true;

    return false;
  }
  messageApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupInstructorEligibilityDTOMeta.message,
      ClassSignupInstructorEligibilityDTOMeta,
      this.message,
      this,
    );
  }
  messageIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.messageIsSet && this.messageApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.statusIsSetDeep(filter)) return true;
    if (this.messageIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
